import {WorkforceTeamCreationState} from '../../../services/payroll-workforce/workforce-team-creation.state';
import {Component, Input, Output, EventEmitter} from '@angular/core';
import {WorkforceBrowseState, WorkforceFilter} from '../../../services/payroll-workforce/workforce-browse.state';

@Component({
  selector: 'app-payroll-workforce-browse',
  templateUrl: './payroll-workforce-browse.component.html',
  styleUrls: ['./payroll-workforce-browse.component.scss'],
})
export class PayrollWorkforceBrowseComponent {
  @Input() state!: WorkforceBrowseState;
  @Input() creation!: WorkforceTeamCreationState;
  @Input() matching: import('../../../services/payroll-workforce/workforce-team-criteria.state').MatchingSelection | null = null;
  @Output() matchingChange = new EventEmitter<import('../../../services/payroll-workforce/workforce-team-criteria.state').MatchingSelection | null>();
  @Output() createTeam = new EventEmitter<void>();
  get creating(): boolean {
    const progress = this.creation?.progress;
    return !!this.creation?.busy || !!progress && !['complete', 'closed'].includes(progress.phase);
  }
  matchingMode = false;
  optionField: WorkforceFilter = 'department';
  optionPrefix = '';
  labels: Record<string, string> = {department: 'Department', location: 'Location', division: 'Division', jobTitle: 'Job title'};
  apply(): void { void this.state.setQuery(this.state.query); }
  choose(value: string): void { this.state.query[this.optionField] = value; this.apply(); }
  clear(field: string): void { delete this.state.query[field]; this.apply(); }
  options(more = false): void { void this.state.loadOptions(this.optionField, this.optionPrefix, more); }
  optionFieldChanged(): void { this.state.options = []; this.state.optionsNext = null; this.optionPrefix = ''; this.options(); }
  trackRow(_index: number, row: {employeeKey: string}): string { return row.employeeKey; }
}
